import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    message: null,
    apiReady: false
  },
  mutations: {
    updateToken(state, payload){
      state.token = payload;
    },
    updateMessage(state, payload){
      state.message = payload;
    }
  },
  actions: {
    updateToken({commit}, payload){
      commit('updateToken', payload);
    },
    updateMessage({commit}, payload){
      commit('updateMessage', payload);
    }
  },
  getters: {
    token(state){
      return state.token;
    },
    message(state){
      return state.message;
    }
  }
})
